'use client'

import Typography from '@mui/material/Typography'
import Image from 'next/image'
import { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import Testimonial from '../../../shared/components/Testimonial'
import testimonialCustomerDesktop from '../../../../public/assets/testimonial-customer-desktop.jpg'
import testimonialCustomerMobile from '../../../../public/assets/testimonial-customer-mobile.jpg'

const TestimonialVideoSection: FC = () => (
  <section className="bg-green-900 py-16 lg:py-24">
    <GridContainer>
      <div className="col-span-full flex flex-col lg:flex-row lg:gap-8 items-stretch">
        <div className="flex-1 flex items-center">
          <Typography variant="h2" sx={{ color: 'white' }} className="mb-8 lg:mb-0">
            Trusted by over
            <br />3 million people
          </Typography>
        </div>
        <div className="flex-1 flex items-center mb-4 lg:mb-0 relative">
          <Image
            src={testimonialCustomerDesktop}
            alt="Mission Lane customer with glasses and a beard speaking in a video testimonial"
            className="hidden lg:block rounded-[16px]"
          />
          <Image
            src={testimonialCustomerMobile}
            alt="Mission Lane customer with glasses and a beard speaking in a video testimonial"
            className="block lg:hidden rounded-[12px]"
          />
        </div>
        <div className="flex-1 flex">
          <Testimonial
            comment="Mission Lane gave me a chance when a lot of other places wouldn't. They saw more than just a number; they saw a person trying to do better."
            customerName="Randy"
            customerLocation="Coeur d'Alene, ID"
          />
        </div>
      </div>
    </GridContainer>
  </section>
)

export default TestimonialVideoSection
